import { render } from "./RbInformationCard.vue?vue&type=template&id=6e34e54d&scoped=true"
import script from "./RbInformationCard.vue?vue&type=script&lang=js"
export * from "./RbInformationCard.vue?vue&type=script&lang=js"

import "./RbInformationCard.vue?vue&type=style&index=0&id=6e34e54d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e34e54d"]])

export default __exports__